import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'rt-selectable-card',
  templateUrl: './selectable-card.component.html',
  styleUrls: ['./selectable-card.component.less'],
})
export class SelectableCardComponent {
  @Input() public control: FormControl;
  @Input() public disabled: boolean = false;
  @Input() public label: string;
  @Input() public description: string;

  @Output() public valueChanges: EventEmitter<string | boolean | null> = new EventEmitter();
}
